// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_hU3","cls2":"common-cls2_VBL common-cls1_hU3"};